import ISTable from 'components/lSTable';
import useToken from 'hooks/useToken';
import PrivateLayout from 'layouts/private';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Grid, Link } from '@mui/material';
import TableButtonsContainer from 'components/TableButtonsContainer';
import { fetchCapitals } from 'apiRequest/capitals';
import { fetchAccountsAll } from 'apiRequest/account';
import { toast } from 'react-hot-toast';
import { defaultError } from 'utils/message';
import SelectInput from 'components/forms/fields/SelectInput';

export default function CapitalList() {
  const { token } = useToken();

  const {
    isError: isErrorAccounts,
    data: accounts,
    error: errorAccounts
  } = useQuery(
    ["account-fetchAccountsAll"],
    () => {
      return fetchAccountsAll({ token });
    });

    if (isErrorAccounts) {
      toast.error(errorAccounts.message || defaultError);
      toast.error('contact admin');
      console.error(errorAccounts);
    }

  const accountOptions = React.useMemo(() => (
    accounts?.data.data.map(({id, name})=>({ value: id, label: name}))
  ), [accounts]);

  const [params, setParams] = useState({
    partials: ['account', 'figure'],
    sort_by: {
      "key": "id",
      "order": "desc"
    }
  });

  const { isLoading, isError, data: capitals, error } = useQuery(
    ["capital-fetchCapitals", params],
    () => {
    return fetchCapitals({ token, params });
  });

  const handlePageChange = (page) => {
    setParams({ ...params, page });
  };

  const hanldeFilterSubmit = (data) => {
    setParams({
      ...params,
      filters: { ...params.filters, ...data }
    });
  };

  const columns = React.useMemo(() => [
    {
      key: 'id',
      label: 'ID',
      selector: row => row.id,
    },
    {
      key: 'currency',
      label: 'Currency',
      selector: row => row.figure.code
    },
    {
      key: 'quantity',
      label: 'Quantity',
      selector: row => row.quantity,
    },
    {
      key: 'amount',
      label: 'Amount',
      currency: true,
      selector: row => row.quantity * row.figure.worth,
    },
    {
      key: 'account',
      label: 'Account',
      selector: row => <Link component={RouterLink} to={`/accounts/${row.account_id}`}>{row.account.name}</Link>,
    },
    {
      key: 'action',
      label: 'Action',
      selector: row => <Link component={RouterLink} to={`/capitals/${row.id}/entries`}>Entries</Link>
    },
  ], []);

  return (
    <PrivateLayout loading={isLoading} isError={isError} error={error}>
      <TableButtonsContainer>
        <Button
          variant="contained"
          component={RouterLink}
          to={`/capitals/create`}
        >
          Add New Capital
        </Button>
      </TableButtonsContainer>

      <ISTable
        title="Capitals"
        maxWidth="md"
        size='medium'
        loading={isLoading}
        columns={columns}
        data={capitals?.data.data}
        pagination
        count={capitals?.data.total}
        page={capitals?.data.current_page}
        rowsPerPage={capitals?.data.per_page}
        onPageChange={handlePageChange}
        filter
        filterSubmit={hanldeFilterSubmit}
        FilterFields={FilterFields}
        filterFields={['account_id']}
        filterFieldsProps={{ accountOptions }}
      />
    </PrivateLayout>
  );
}

const FilterFields = ({ accountOptions }) => {
  return (
    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2} width="250px" >
      <Grid item xs={12}>
        <SelectInput field="account_id" label="Account" size="small" margin="none" helperText={false}
          options={accountOptions}
        />
      </Grid>
    </Grid>
  );
};

